import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import SimpleBox from "../layout/container/SimpleBox";

const PersonCard = ({ name, photoUrl, gender, subtitle, forceSubtitleSpace = false }) => {
    const theme = useTheme();
    const genderLower = gender.toLowerCase();
    const photoSrc = photoUrl ? photoUrl : `${process.env.PUBLIC_URL}/img/no-photo-${genderLower}.png`;

    return (
        <SimpleBox flexDirection="column">
            <Box
                component="img"
                src={photoSrc}
                alt={name}
                sx={{
                    width: '240px',
                    height: '240px',
                    borderTopLeftRadius: theme.spacing(5),
                    borderTopRightRadius: theme.spacing(5),
                    boxShadow: theme.shadows[5],
                }}
            />
            <Box
                sx={{
                    width: "100%",
                    paddingTop: theme.spacing(2),
                    paddingBottom: theme.spacing(2),
                    backgroundColor: theme.palette.whiteSmoke.main,
                    borderBottomLeftRadius: theme.spacing(5),
                    borderBottomRightRadius: theme.spacing(5),
                    boxShadow: theme.shadows[5],
                }}
            >
                {
                    Boolean(subtitle) || forceSubtitleSpace ? (
                        <Box sx={{ height: "1.5em" }}>
                            <Typography sx={{ color: theme.palette.davysGray.dark, textAlign: "center", fontSize: "0.9em", fontWeight: "bold", fontVariant: "all-petite-caps" }}>
                                {subtitle ?? "-"}
                            </Typography>
                        </Box>
                    ) : null
                }
                <Typography sx={{ color: theme.palette.raisinBlack.main, textAlign: "center", fontSize: "1.2em", fontWeight: "bold", fontVariant: "small-caps" }}>
                    {name}
                </Typography>
            </Box>
        </SimpleBox>
    );
}

export default PersonCard;
